import React from 'react';

const Panel = ({ children, className }) => (
  <div className={`${className} panel p-4 shadow-sm bg-white mb-4 rounded-lg`}>
    {children}
  </div>
);


export default Panel;
